import React from 'react';
import { Link } from 'react-router-dom';



// image
import Ab from '../../images/about/img-1.jpg'
import Abd1 from '../../images/about/img-2.jpg'
import Abd2 from "../../images/about/img-7.jpg"

const about = (props) => {
    const ClickHandler = () => {
        window.scrollTo(10, 0);
    }
    return (
        <section className={"" + props.hclass}>
            <div className="container">
                <div className="wpo-about-section-wrapper">
                    <div className="row align-items-center">
                        <div className="col-xl-6 col-lg-12 col-md-12 col-12">
                            <div className="wpo-about-img">
                                <div className="wpo-about-img-left">
                                    <img src={Ab} alt="" />
                                </div>
                                <div className="about-img-inner">
                                    {/* <div className="about-img-inner-text">
                                        <h2>38 <span>Years of <br /> experiecne.</span></h2>
                                        <p>It was popularised with the release sheets and more recently.</p>
                                    </div> */}
                                    <img src={Abd2} className='mb-3 about-7' alt="" />
                                    <img src={Abd1} alt="" />
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-6 col-lg-12 col-md-12 col-12">
                            <div className="wpo-about-content ">
                                <div className="wpo-about-content-top">
                                    <h2>About Us</h2>
                                    <p>LLC "TEZROH" - is a transport company that has been providing quality transportation services for over 5 years. We offer quality cargo delivery at the best prices in the CIS and Baltic countries.</p>
                                </div>
                                <div className="wpo-about-content-progress">
                                    <div className="progress-inner">
                                        <div className="progress yellow">
                                            <span className="progress-left">
                                                <span className="progress-bar"></span>
                                            </span>
                                            <span className="progress-right">
                                                <span className="progress-bar"></span>
                                            </span>
                                            <div className="progress-value">98%</div>
                                            <div className="progress-name"><span>Success</span></div>
                                        </div>
                                    </div>
                                    <p>At the same time, the geography of our work is steadily expanding and we are happy to work for you.</p>
                                </div>
                                <div className="wpo-about-check-wrap">
                                    <div className="wpo-about-check-item">
                                        <p>Each client of the company is provided with an individual approach taking into account the optimization of costs and the offer of the best way to deliver goods. The company's service "from door to door" speaks for itself including the full range of services provided by us.</p>
                                    </div>
                                    <div className="wpo-about-check-item">
                                        <p>The development of the organization occurs due to profit, without bank mortgages and loans. We fulfill our obligations in good faith to clients as well as to our contractors, thanks to whom a trusting cooperation has been established for more than one year.</p>
                                    </div>
                                </div>
                                <Link onClick={ClickHandler} to="/service" className="theme-btn-s2">All services</Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default about;

